export default __webpack_public_path__ + "static/media/question-circle.d2f61a19.svg";